const emailVerifyConstant = {
  API_TYPE: {
    EMAIL_VERIFY: "EMAIL_VERIFY",
  },
};

export default emailVerifyConstant;

